import * as configDefault from "./config.default";

const API_ENDPOINT = "${API_ENDPOINT}";

const config = {
  API_ENDPOINT: API_ENDPOINT.startsWith("$")
    ? configDefault.API_ENDPOINT
    : configDefault.normalizeApiEndpoint(API_ENDPOINT),
};
export default config;
